import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Senza latticini',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Piccante',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Vegano',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Senza glutine',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Vegetariano',
};
